import {
  textUI,
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  selectUI,
  checkboxUI,
  checkboxSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  STATE_VALUES,
  STATE_NAMES,
  COUNTRY_VALUES,
  COUNTRY_NAMES,
} from '../../../utils/labels';
import { customAddressSchema } from '../../definitions';
import { validations } from '../../validations';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-veteran-marriage-end-info-title']),
    marriageToVeteranEndDate: currentOrPastDateUI({
      title: content['household-veteran-marriage-end-info-date'],
      monthSelect: false,
      validations: [validations.isAfterMarriageStartDate],
    }),
    marriageToVeteranEndOutsideUs: checkboxUI({
      title: content['household-veteran-marriage-end-info-outside-us'],
    }),
    marriageToVeteranEndLocation: {
      city: {
        ...textUI(content['address-city']),
        'ui:errorMessages': {
          required: content['address-city-error'],
        },
      },
      state: {
        ...selectUI(content['address-state']),
        'ui:required': formData => !formData?.marriageToVeteranEndOutsideUs,
        'ui:options': {
          hideIf: formData => formData?.marriageToVeteranEndOutsideUs,
          labels: STATE_VALUES.reduce((acc, value, idx) => {
            acc[value] = STATE_NAMES[idx];
            return acc;
          }, {}),
        },
        'ui:errorMessages': {
          required: content['address-state-error'],
        },
      },
      otherCountry: {
        ...selectUI(content['address-country']),
        'ui:required': formData => formData?.marriageToVeteranEndOutsideUs,
        'ui:options': {
          hideIf: formData => !formData?.marriageToVeteranEndOutsideUs,
          labels: COUNTRY_VALUES.reduce((acc, value, idx) => {
            acc[value] = COUNTRY_NAMES[idx];
            return acc;
          }, {}),
        },
        'ui:errorMessages': {
          required: content['address-country-error'],
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['marriageToVeteranEndDate', 'marriageToVeteranEndLocation'],
    properties: {
      marriageToVeteranEndDate: currentOrPastDateSchema,
      marriageToVeteranEndOutsideUs: checkboxSchema,
      marriageToVeteranEndLocation: customAddressSchema,
    },
  },
};
